module.exports = __webpack_public_path__ + "img/klaim.a6d4b286.svg";